"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var utils_1 = require("../../utils");
var DevicesSubmodule = /** @class */ (function () {
    function DevicesSubmodule(model) {
        this.model = model;
    }
    DevicesSubmodule.prototype.getDeviceById = function (deviceId) {
        var _this = this;
        return axios_1.default
            .get(this.model.baseUrl + "/devices/" + deviceId, {
            headers: {
                Authorization: "Bearer " + this.model.accessToken,
            },
        })
            .then(function (res) { return _this.parse(res.data); })
            .catch(function (err) {
            throw new Error((0, utils_1.extractAxiosErrorMessage)(err));
        });
    };
    DevicesSubmodule.prototype.getDevices = function () {
        var _this = this;
        return axios_1.default
            .get(this.model.baseUrl + "/devices", {
            headers: {
                Authorization: "Bearer " + this.model.accessToken,
            },
        })
            .then(function (res) { return res.data.results.map(function (json) { return _this.parse(json); }); })
            .catch(function (err) {
            throw new Error((0, utils_1.extractAxiosErrorMessage)(err));
        });
    };
    DevicesSubmodule.prototype.createDevice = function (data) {
        var _this = this;
        return axios_1.default
            .post(this.model.baseUrl + "/devices", data, {
            headers: {
                Authorization: "Bearer " + this.model.accessToken,
            },
        })
            .then(function (res) { return _this.parse(res.data); })
            .catch(function (err) {
            throw new Error((0, utils_1.extractAxiosErrorMessage)(err));
        });
    };
    DevicesSubmodule.prototype.deleteDevice = function (deviceId) {
        return axios_1.default
            .delete(this.model.baseUrl + "/devices/" + deviceId, {
            headers: {
                Authorization: "Bearer " + this.model.accessToken,
            },
        })
            .then(function () { return undefined; })
            .catch(function (err) {
            throw new Error((0, utils_1.extractAxiosErrorMessage)(err));
        });
    };
    DevicesSubmodule.prototype.parse = function (json) {
        return __assign(__assign({}, json), { newestDate: new Date(json.newestDate), oldestDate: json.oldestDate === null ? json.oldestDate : new Date(json.oldestDate), createdAt: new Date(json.createdAt), updatedAt: new Date(json.updatedAt) });
    };
    return DevicesSubmodule;
}());
exports.default = DevicesSubmodule;
